<template>
  <div>
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane
        name="capacitance_readings"
        v-if="p('Pods.Capacitance Readings Chart.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">{{ $t('text.capacitance_readings') }}</div>
          <div class="label-desc">
            {{ $t('text.capacitance_sensor_readings') }}
          </div>
        </div>
        <CapacitanceReadings
          ref="capacitanceReadings"
          v-if="activeName === 'capacitance_readings'"
          :tooltip="tooltip"
        ></CapacitanceReadings>
      </el-tab-pane>
      <el-tab-pane
        name="connection_status"
        v-if="p('Pods.Connection Status Chart.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">{{ $t('text.connection_status') }}</div>
          <div class="label-desc">{{ $t('text.pad_connections') }}</div>
        </div>
        <ConnectionStatus
          ref="connectionStatus"
          v-if="activeName === 'connection_status'"
          :tooltip="tooltip"
        />
      </el-tab-pane>
      <el-tab-pane
        name="battery_levels"
        v-if="p('Pods.Battery Levels Chart.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">Battery Voltage</div>
          <div class="label-desc">
            Battery voltage and status
          </div>
        </div>
        <BatteryLevels
          ref="batteryLevels"
          v-if="activeName === 'battery_levels'"
          :tooltip="tooltip"
        />
      </el-tab-pane>
      <el-tab-pane
        name="accelerometer_readings"
        v-if="p('Pods.Accelerometer Readings Chart.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">{{ $t('text.accelerometer_readings') }}</div>
          <div class="label-desc">{{ $t('text.ax_ay_az') }}</div>
        </div>
        <AccelerometerReadings
          ref="accelerometerReadings"
          v-if="activeName === 'accelerometer_readings'"
          :tooltip="tooltip"
        />
      </el-tab-pane>
      <el-tab-pane name="temperature" v-if="p('Pods.Temperature Chart.View')">
        <div class="left-tab-label" slot="label">
          <div class="label-title">Temperature</div>
          <div class="label-desc">Temperature</div>
        </div>
        <Temperature
          ref="temperature"
          v-if="activeName === 'temperature'"
          :tooltip="tooltip"
        />
      </el-tab-pane>
      <el-tab-pane name="spo2" v-if="p('Pods.SPO2 Chart.View')">
        <div class="left-tab-label" slot="label">
          <div class="label-title">{{ $t('text.spo2') }}</div>
          <div class="label-desc">{{ $t('text.blood_oxygen_saturation') }}</div>
        </div>
        <Spo2 ref="spo2" v-if="activeName === 'spo2'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import $ from 'jquery'
import CapacitanceReadings from '@/components/pods/chartData/CapacitanceReadings'
import ConnectionStatus from '@/components/pods/chartData/ConnectionStatus'
import BatteryLevels from '@/components/pods/chartData/BatteryLevels'
import AccelerometerReadings from '@/components/pods/chartData/AccelerometerReadings'
import Temperature from '@/components/pods/chartData/Temperature'
import Spo2 from '@/components/pods/chartData/Spo2'
import moment from 'moment-timezone'

export default {
  data() {
    return {
      activeName: 'capacitance_readings',
      screenWidth: window.innerWidth,
      tooltip: {
        trigger: 'axis',
        formatter(params) {
          let tooltipStr = `<div>${moment(params[0].axisValue).format(
            'DD/MM/YY HH:mm:ss'
          )}</div>`
          params.forEach(item => {
            if (tooltipStr.indexOf(item.color) < 0) {
              tooltipStr =
                tooltipStr +
                `<div><div style="display:inline-block; margin-right: 5px; width: 10px; height: 10px; border-radius: 5px; background-color:${
                  item.color
                }"></div>${item.seriesName} : ${
                  item.value[item.seriesIndex + 1]
                }</div>`
            }
          })
          return tooltipStr
        }
      }
    }
  },
  mounted: function() {
    if (this.$permission('Pods.Capacitance Readings Chart.View')) {
      this.activeName = 'capacitance_readings'
    } else if (this.$permission('Pods.Connection Status Chart.View')) {
      this.activeName = 'connection_status'
    } else if (this.$permission('Pods.Battery Levels Chart.View')) {
      this.activeName = 'battery_levels'
    } else if (this.$permission('Pods.Accelerometer Readings Chart.View')) {
      this.activeName = 'accelerometer_readings'
    } else if (this.$permission('Pods.Temperature Chart.View')) {
      this.activeName = 'temperature'
    } else {
      this.activeName = 'spo2'
    }
    window.addEventListener('resize', this.getScreenWidth)
    setTimeout(() => {
      this.toggleNavArrow()
      if (this.screenWidth <= 1023) {
        this.listenNavBtnClick()
      }
    }, 50)
  },
  components: {
    CapacitanceReadings,
    ConnectionStatus,
    BatteryLevels,
    AccelerometerReadings,
    Spo2,
    Temperature
  },
  watch: {
    activeName() {
      this.toggleNavArrow()
    }
  },
  methods: {
    listenNavBtnClick() {
      var nextBtn = document.getElementsByClassName('el-tabs__nav-next')
      nextBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-next').hide()
          $('.el-tabs__nav-prev').show()
        },
        true
      )
      var prevBtn = document.getElementsByClassName('el-tabs__nav-prev')
      prevBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-prev').hide()
          $('.el-tabs__nav-next').show()
        },
        true
      )
    },
    toggleNavArrow() {
      if (this.activeName === 'spo2') {
        $('.el-tabs__nav-next').hide()
      } else {
        $('.el-tabs__nav-next').show()
      }
      if (this.activeName === 'capacitance_readings') {
        $('.el-tabs__nav-prev').hide()
      } else {
        $('.el-tabs__nav-prev').show()
      }
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    }
  }
}
</script>
